import { useEffect, useState } from "react"

export default function DuplicateAlert(props) {
    const [dupISBN, setDupISBN] = useState([]);
    const [dupAddISBN, setDupAddISBN] = useState([]);

    useEffect(() => {
        const isbns = [...new Set(props.duplicateRow.filter(i => !i.additionalRow).map(i=>i.isbn))];
        const additionalcvr = [...new Set(props.duplicateRow.filter(i => i.additionalRow).map(i=>i.isbn))];
    setDupISBN(isbns);
    
        setDupAddISBN(additionalcvr);
    }, [])
    return (
        <>
          
                <div className="delete-warning-rpt">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content modal-content-dup">
                                <div className="modal-header p-2 ml-2">
                                <h6 className="modal-title modal-title-dup">Duplicates</h6> 
                                    <button type="button" className="close" onClick={props.onClose} aria-label="Close" >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            <div className="modal-body modal-body-dup">

                                <p className="m-0">There are <span className="fw-bold">{props.duplicateRow.length}</span> duplicates, please review following duplicates:</p>
                                <table className="border-duplicate">
                                    <tr>
                                        <th className="dup-alert-tbl-head  border-duplicate">ISBN without Additional Covers/Jackets: </th>
                                        <th className="dup-alert-tbl-head  border-duplicate">ISBN with Additional Covers/Jackets: </th>
                                    </tr>
                                    <tr>
                                        <td className="border-duplicate table-isbn"><ul>
                                            {dupISBN?.length > 0 && dupISBN.slice(0, 15).map(i => (<li>{i}</li>))}
                                            {dupISBN.length > 15 && <p title={dupISBN}> &nbsp;.....</p>}
                                        </ul>
                                         

                                        </td>
                                        <td className="border-duplicate table-isbn">
                                            <ul >
                                                {dupAddISBN?.length > 0 && dupAddISBN.slice(0, 15).map(i => (<li>{i}</li>))}
                                                {dupAddISBN.length > 15 && <p title={dupAddISBN}> &nbsp;...</p>}
                                            </ul>
                                        </td>
                                    
                                    </tr>
                                </table>
                                   {/* <p>ISBN : {dupISBN}</p> 
                                    <p>Additional Covers/Jackets : {dupAddISBN}</p>*/}
                                
                                </div>
                                <div className="modal-footer">
                                 {/*   <button type="button" className="btn btn-secondary mr-2" onClick={props.onOverRide} >Yes</button>*/}
                                    <button type="button" className="btn btn-secondary ml-2" onClick={props.onClose} >Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </div>
           
        </>
    )
}